import type { FC } from 'react';
import { useStore } from 'zustand';

import { ModalBody } from 'Features/SellerCommunications/components/ModalBody';
import { ModalLoading } from 'Features/SellerCommunications/components/ModalLoading';
import { EnquiriesSelectStore } from 'Features/SellerCommunications/services';
import { T } from 'Features/SellerCommunications/utils/translate';

import styles from './MarkAsContactedLoading.module.scss';

export const MarkAsContactedLoading: FC = () => {
	const selectedSalesCount = useStore(EnquiriesSelectStore, ({ selectedSaleIds }) => selectedSaleIds.length);

	return (
		<ModalBody className={styles.container}>
			<ModalLoading
				description={T.translate(
					`markAsContacted.loading.description.${selectedSalesCount > 1 ? 'multiple' : 'single'}`,
					{
						count: selectedSalesCount,
					},
				)}
				title={T.translate('markAsContacted.loading.title')}
			/>
		</ModalBody>
	);
};
